import React from 'react'
import styled from 'styled-components'

const QuickButton = ({ button, onQuickButtonClicked }) => {
  return (
    <QuickButtonContainer onClick={(event) => onQuickButtonClicked(button.toJS())}>
      {button.get('text')}
    </QuickButtonContainer>
  )
}

export default QuickButton

const QuickButtonContainer = styled.button`
  background: var(--clr-bot-main, ${props => props.theme.primaryColor});
  border-radius: 5px;
  border: 1px solid var(--clr-bot-main, ${props => props.theme.primaryColor});
  color: ${props => props.theme.secondaryColor};
  font-weight: bold;
  padding: 8px;
  cursor: pointer;
  opacity: 1;

  &:hover, &:active {
    opacity: 0.9;
  }
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/QuickButtons/Button.js